module.exports = __webpack_public_path__ + "static/img/edit.f032fc16.svg";